import React, { useState, useEffect } from "react"

import _isEmpty from "lodash/isEmpty"
import { mapStateToCountryHandler, validateField } from "@/utils/helper"
import Input from "@/components/core/Input/Input"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"
import Button from "@/components/core/Button/Button"
import {
  getstateList,
  getCountryList,
  selectGenericState,
  getOccupationList,
} from "@/store/features/genericSlice"
import { useDispatch, useSelector } from "react-redux"

const Form = props => {
  const { data, setData, i18n, error, onSubmit, teaserComponent, loading } =
    props
  const dispatch = useDispatch()
  const [occupation, setOccupation] = useState([])

  const [countries, setCountries] = useState([])
  const [stateList, setStateList] = useState([])

  useEffect(() => {
    setData({ ...data, state: {} })
  }, [data.country])

  useEffect(() => {
    const userEmail = window?.location?.href?.includes?.("?email=")
      ? window?.location?.href?.split?.("=")?.[1]
      : ""
    if (userEmail)
      setData({
        ...data,
        email: userEmail,
      })
  }, [teaserComponent])

  const { countryListPath, stateListPath, occupationListPath } =
    useSelector(selectGenericState)

  useEffect(() => {
    try {
      if (
        !_isEmpty(countryListPath) &&
        !_isEmpty(stateListPath) &&
        !_isEmpty(occupationListPath)
      )
        getLocations()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
    }
  }, [countryListPath, stateListPath, occupationListPath])

  const getLocations = async () => {
    if (countryListPath && stateListPath && occupationListPath) {
      const countryData = await dispatch(getCountryList())
      const stateData = await dispatch(getstateList())
      const occupationList = await dispatch(getOccupationList())
      const mapList =
        (!_isEmpty(countryData?.payload) &&
          !_isEmpty(stateData?.payload) &&
          mapStateToCountryHandler(countryData?.payload, stateData?.payload)) ||
        []
      setCountries(mapList)
      setStateList(mapList.find(country => country.code === "US")?.states ?? [])
      setOccupation(occupationList?.payload)
      setData({
        ...data,
        country: mapList.find(country => country.code === "US") ?? {},
      })
    }
  }

  const onNameChange = async e => {
    const { id, value } = e.target
    const field = id.split("-")
    if (value === "" || (await validateField("name", value))) {
      setData({
        ...data,
        [field[2]]: value,
      })
    }
  }

  const selectOccupation = occupation => {
    setData({ ...data, occupation })
    props.setError({
      ...error,
      occupation: false,
    })
  }

  const onInputChange = async (e, zipChange = false) => {
    const { id, value } = e.target
    const field = id.split("-")
    if (zipChange) {
      if (value === "" || (await validateField("zipCodeNumeric", value))) {
        setData({
          ...data,
          [field[2]]: value,
        })
      }
    } else {
      setData({
        ...data,
        [field[2]]: value,
      })
    }
  }

  const changeCountry = country => {
    setStateList(countries?.find(c => c?.name === country)?.states ?? [])
    setData({
      ...data,
      country: countries?.find(c => c?.name === country),
    })
  }

  const changeState = state => {
    setData({ ...data, state: { code: state } ?? {} })
    props.setError({
      ...error,
      state: false,
    })
  }
  const checkDisabled = userdata => {
    if (
      userdata?.fname?.trim() &&
      userdata?.lname?.trim() &&
      userdata?.email?.trim() &&
      userdata?.zipcode &&
      userdata?.state &&
      userdata?.occupation?.trim()
    )
      return false
    return true
  }

  return (
    <>
      <fieldset>
        <div className="contact-title">
          <div className="contact-title__fields">
            <span className="required-fields">{i18n.requiredInfoText}</span>
          </div>
        </div>
        <div className="container contact-info-form mb-40">
          <div className="row mx-0">
            <div className="user-email col-12 px-0">
              <Input
                id="contact-user-email"
                type="text"
                value={data.email}
                maxLength={60}
                placeholder={`${i18n.email}*`}
                label={`${i18n.email}*`}
                onChange={onInputChange}
                showError={error?.email}
                errorMessage={error?.email}
                onBlur={() => props.onBlur("email")}
                autoComplete="email"
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className={`user-fname col-12 px-0`}>
              <Input
                id="contact-user-fname"
                type="text"
                value={data.fname}
                maxLength={40}
                placeholder={`${i18n.fname}*`}
                label={`${i18n.fname}*`}
                onChange={onNameChange}
                showError={error.fname}
                errorMessage={error.fname}
                onBlur={() => props.onBlur("fname")}
                autoComplete="given-name"
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className={`user-lname col-12 px-0`}>
              <Input
                id="contact-user-lname"
                type="text"
                value={data.lname}
                maxLength={40}
                placeholder={`${i18n.lname}*`}
                label={`${i18n.lname}*`}
                onChange={onNameChange}
                showError={error.lname}
                errorMessage={error.lname}
                onBlur={() => props.onBlur("lname")}
                autoComplete="family-name"
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className={`user-state col-12 px-0`}>
              <Dropdown
                id="contact-user-state"
                customClass="input-field"
                data={stateList ?? [] ?? []}
                value={data.state.code ?? ""}
                label={`${i18n.state}*`}
                onChange={changeState}
                showError={error.state}
                errorMessage={error.state}
                onBlur={() => props.onBlur("state")}
                ariaStateText={true}
                showStateName={true}
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className="user-zipcode col-12 px-0">
              <Input
                id="contact-user-zipcode"
                type="text"
                value={data.zipcode}
                maxLength={7}
                autoComplete="postal-code"
                placeholder={`${i18n.zipcode}*`}
                label={`${i18n.zipcode}*`}
                onChange={e => onInputChange(e, true)}
                showError={error.zipcode}
                errorMessage={error.zipcode}
                onBlur={() => props.onBlur("zipcode")}
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className={`user-country col-12 px-0`}>
              <Dropdown
                id="contact-user-country"
                customClass="input-field"
                data={countries.map(country => country?.name)}
                name="country"
                value={data.country.name ?? ""}
                label={`${i18n.country}`}
                onChange={changeCountry}
                showError={error.country}
                errorMessage={error.country}
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <Dropdown
                id="contact-user-occupation-type"
                data={occupation?.map(el => el.text)}
                value={data?.occupation ?? ""}
                label={`${i18n.occupation}*`}
                onChange={selectOccupation}
                showError={error.occupation}
                errorMessage={error.occupation}
                onBlur={() => props.onBlur("occupation")}
              />
            </div>
          </div>
        </div>
      </fieldset>
      <Button
        className="lead-gen-footer__submit-button"
        role="button"
        id="submit-membership-form-button"
        disabled={checkDisabled(data)}
        onClick={onSubmit}
        type="black"
        label={i18n.subscribe}
        loading={loading}
        flexible
      />
    </>
  )
}

export default Form
